export const errorMessage = {
  preview404: "Não foi possível gerar a pré-visualização da imagem.",
  read404: "Não foi possível ler a imagem selecionada.",
  sizeMax: "Tamanho máximo de 5MB excedido",
  invalidType: "Formato de imagem inválido",
};

export const { read404, preview404, invalidType, sizeMax } = errorMessage;
